export const VIEW_CEREBRUMX_INTEGRATION_REQUEST = "VIEW_CEREBRUMX_INTEGRATION_REQUEST";
export const VIEW_CEREBRUMX_INTEGRATION_RESULT = "VIEW_CEREBRUMX_INTEGRATION_RESULT";
export const VIEW_CEREBRUMX_INTEGRATION_OPEN_MODAL = "VIEW_CEREBRUMX_INTEGRATION_OPEN_MODAL";
export const VIEW_CEREBRUMX_INTEGRATION_CLOSE_MODAL = "VIEW_CEREBRUMX_INTEGRATION_CLOSE_MODAL";
export const VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_REQUEST = "VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_REQUEST";
export const VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_RESULT = "VIEW_CEREBRUMX_INTEGRATION_GET_INTEGRATION_RESULT";

export const VIEW_CEREBRUMX_INTEGRATION_SET_INTEGRATIONS = "VIEW_CEREBRUMX_INTEGRATION_SET_INTEGRATIONS";
export const VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_REQUEST = "VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_REQUEST";
export const VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_RESULT = "VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_RESULT";

